import { render, staticRenderFns } from "./DownloadSvg.vue?vue&type=template&id=6d65fd22&scoped=true"
import script from "./DownloadSvg.vue?vue&type=script&lang=js"
export * from "./DownloadSvg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d65fd22",
  null
  
)

export default component.exports